import React from 'react'
import {Button, Panel} from 'react-bootstrap'

export default class DataPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    };
  }

  generateErrorOrWarning() {
    const elements = [
      'failed_job_count',
      'scores_updated'
    ]
    const res = {}
    elements.forEach(ele => (res[ele] = (this._getKlassName(ele) || 'default')))
    return res
  }

  _getKlassName(ele) {
    const data = this.props.data;
    switch(ele) {
      case 'failed_job_count':
        if(data.delayed_jobs.failed_jobs>10) {
          return 'danger'
        }else if(data.delayed_jobs.failed_jobs>4) {
          return 'warning'
        }else {
          return
        }
      case 'scores_updated':
        if(data.scores.delay>10) {
          return 'danger'
        }else if(data.scores.delay>4) {
          return 'warning'
        }else {
          return
        }
      default:
        return;
    }
  }

  _getPanelKlassName(errorOrWarning) {
    let values = Object.values(errorOrWarning)
    if(values.includes('danger')) {
      return 'danger'
    }else if(values.includes('warning')) {
      return 'warning'
    }else {
      ''
    }
  }

  render() {
    const data = this.props.data;
    const errorOrWarning = this.generateErrorOrWarning();
    const panelKlassName = this._getPanelKlassName(errorOrWarning);

    return (
      <div className='DataPanel'>
        <Panel id="collapsible-panel-example-2" defaultExpanded={this.state.open} bsStyle={panelKlassName}>
          <Panel.Heading>
            <Panel.Title toggle>
              MONITORING DATA
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <h6 className='title'>DELAYED JOBS</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.failed_job_count}`}>
                  Failed Job Count :
                </dt>
                <dd className={`text-${errorOrWarning.failed_job_count}`}>{data.delayed_jobs.failed_jobs}</dd>
              </dl>
              <hr/>
              <h6 className='title'>CLASSIFICATION SCORES</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.scores_updated}`}>
                  Last Updated :
                </dt>
                <dd className={`text-${errorOrWarning.scores_updated}`}>{data.scores.last_updated}</dd>
              </dl>

            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Monitoring/DataPanel.jsx